/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
//import createPersistedState from "vuex-persistedstate"


// Store functionality
import actions from './actions'
import getters from './getters'
import app from './modules/app'
import login from '@/views/Login/_store'
import usuario from '@/views/Usuario/_store'
import cliente from '@/views/Cliente/_store'
import municipio from '@/views/Municipio/_store'
import colaborador from '@/views/Colaborador/_store'
import detentora from '@/views/Detentora/_store'
import categoria from '@/views/Categoria/_store'
import pendencia from '@/views/Pendencia/_store'
import statusprocesso from '@/views/StatusProcesso/_store'
import tipocontato from '@/views/TipoContato/_store'
import tipoprocesso from '@/views/TipoProcesso/_store'
import fornecedor from '@/views/Fornecedor/_store'
import processo from '@/views/Processo/_store'
import kit from '@/views/Kits/_store'
import enums from './modules/enums'
import atendimento from '@/views/Atendimento/_store'
import modalidade from '@/views/Modalidade/_store'
import integrador from '@/views/IntegradoresApi/_store'
import prematricula from '@/views/PreMatricula/_store'


import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  mutations,
  actions,
  modules: {
    enums,
    login,
    usuario,
    app,
    cliente,
    municipio,
    colaborador,
    categoria,
    pendencia,
    statusprocesso,
    kit,
    tipocontato,
    fornecedor,
    processo,
    tipoprocesso,
    atendimento,
    detentora,
    modalidade,
    integrador,
    prematricula
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js